module.exports = __webpack_public_path__ + "static/img/smt_voucher_content.d2bf5076.png";